import { createSlice } from "@reduxjs/toolkit";


// Then, handle actions in your reducers:
const popupSlice = createSlice({
  name: "categories",
  initialState: {
    id: null,
    visibility: false,
    logout: false
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    showLogoutPopup(_state, _action) {
      return { logout: true };
    },
    hidePopup(state, _action) {
      return { ...state, visibility: false, logout: false };
    },
    showPopup(_state, action) {
      return { id: action.payload.id, visibility: true };
    },
  },
});

export const { hidePopup, showPopup, showLogoutPopup } = popupSlice.actions;
export default popupSlice.reducer;
